import React, { FC, useEffect, useMemo, useState } from "react"
import { useStore } from "../../stores/utils/use-store"
import { Button, Modal, Switch, Table } from "antd"
import { EditGamesModals } from "./edit-games-modals"
import { GameCategoryOrderColumns } from "./components/columns"
import { GameCategoryOrderBaseType, GameCategoryOrderType } from "./store/game-category-order.store"
import { observer } from "mobx-react"
import { EditIconButton } from "../../components"

const GameCategoryOrder: FC = observer<FC>(() => {
  const [isModalVisible, setIsModalVisible] = useState<"create" | "edit" | null>(null)
  const { dataStore: { gameCategoryOrderStore } } = useStore()

  useEffect(() => {
    gameCategoryOrderStore.getGames().then()
    gameCategoryOrderStore.getGamePlatforms().then()
  }, [gameCategoryOrderStore])

  const onClose = () => {
    setIsModalVisible(null)
  }

  const onEditModalOpen = (record: GameCategoryOrderType) => {
    gameCategoryOrderStore.selectedElement = record
    setIsModalVisible("edit")
  }

  const onEditGame = async(e: GameCategoryOrderType) => {
    await gameCategoryOrderStore.updateGame(e)
    await gameCategoryOrderStore.getGames()
  }

  const columns = useMemo(() => [
    ...GameCategoryOrderColumns,
    {
      title: "Active",
      dataIndex: "isActive",
      render: (isActive: boolean, el) => (
        <div onClick={e => e.stopPropagation()}>
          <Switch
            onClick={() => onEditGame({ ...el, isActive: !el.isActive })}
            disabled={gameCategoryOrderStore.isLoading}
            checked={isActive}
          />
        </div>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: GameCategoryOrderType) => (
        <EditIconButton
          onClick={() => onEditModalOpen(record)}
        />
      ),
    },
  ], [gameCategoryOrderStore.games])

  const onCreateGame = async(e: GameCategoryOrderBaseType) => {
    await gameCategoryOrderStore.createTransactionBuffPlay(e)
    await gameCategoryOrderStore.getGames()
  }

  return (
    <>
      <div>
        <Button type="primary" onClick={() => setIsModalVisible("create")} style={{ marginBottom: 10 }}>
          Create new order
        </Button>
      </div>
      <Table
        dataSource={gameCategoryOrderStore.games || []}
        loading={gameCategoryOrderStore.isLoading}
        columns={columns}
        rowKey="id"
        pagination={false}
      />

      {isModalVisible && (
        <Modal
          visible
          title={isModalVisible === "edit" ? "Edit ordering" : "Create new ordering"}
          width="900px"
          footer={null}
          onCancel={onClose}
          style={{ top: "10px" }}
        >
          <EditGamesModals editType={isModalVisible} onClose={onClose} onSubmit={isModalVisible === "edit" ? onEditGame : onCreateGame} />
        </Modal>
      )}
    </>
  )
})

export default GameCategoryOrder
